import React, { useContext, useEffect, useState } from 'react';

import { Button as AriakitButton } from '@ariakit/react';
import classNames from 'classnames';

import { SearchContext } from '../../context/SearchContext';
import { isAppleDevice } from '../../utils';

import * as classes from './style.module.scss';

interface Props {
  siteName: string;
  className?: string;
}

export const Search: React.FC<Props> = ({ siteName, className }) => {
  const { openSearch } = useContext(SearchContext);
  const [cmdOrCtrl, setcmdOrCtrl] = useState('Ctrl');
  useEffect(() => {
    if (isAppleDevice()) {
      setcmdOrCtrl('⌘');
    }
  });

  return (
    <div className={classNames(classes.root, className)}>
      <AriakitButton
        aria-label="Search the documentation"
        className={classes.button}
        onClick={openSearch}
      >
        {`Search ${siteName}`}
        <div className={classes.hotkey}>{cmdOrCtrl}K</div>
      </AriakitButton>
    </div>
  );
};
